import { GOODS_TYPE } from '@/config'
/**
 * 商品相关逻辑
 */
export default class {
  static isOwnGoods(goodsType) {
    return GOODS_TYPE.own === +goodsType
  }
  static isJointGoods(goodsType) {
    return GOODS_TYPE.joint === +goodsType
  }
  /**
   * 定制SKU商品
   */
  static isSKUGoods(source, goodsType) {
    return this.isOwnGoods(goodsType) && +source === 5
  }
}
